/* eslint-disable react/prop-types */
import { useCallback, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { CompanyService } from "services/companyService";
import { GeneralJournalService } from "services/general-journal";
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";

const currentYear = String(new Date().getFullYear());

const tableData = {
  columns: [
    { Header: "Mã tài khoản", accessor: "accountCode", width: "15%" },
    { Header: "Tên tài khoản", accessor: "accountName", width: "70%" },
    { Header: "Thao tác", accessor: "action", sorted: false, align: "center" },
  ],
  rows: [],
};

export default function LedgerJournal() {
  const [companyId, setCompanyId] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataTableState, setDataTableState] = useState(tableData);
  const [filters, setFilters] = useState({
    year: currentYear,
    searchBy: "",
  });
  const [query, setQuery] = useState({
    year: currentYear,
    searchBy: "",
  });
  const [paginationData, setPaginationData] = useState({ page: 1, count: 0, size: 10 });

  useEffect(() => {
    const init = async () => {
      const response = await CompanyService.getByAuth();
      const payload = response?.data || response || {};
      setCompanyId(payload?._id || "");
    };
    init();
  }, []);

  const fetchData = useCallback(async () => {
    if (!companyId || !query.year) {
      setDataTableState((prev) => ({ ...prev, rows: [] }));
      setPaginationData((prev) => ({ ...prev, count: 0 }));
      return;
    }

    try {
      setLoading(true);
      const response = await GeneralJournalService.getLedgerJournalAccounts({
        company: companyId,
        year: Number(query.year),
        searchBy: query.searchBy || undefined,
        page: paginationData.page,
        limit: paginationData.size,
      });
      const payload = response?.data || response || {};
      const items = payload.items || [];

      setPaginationData((prev) => ({
        ...prev,
        count: payload.paginate?.count || items.length,
        size: payload.paginate?.size || items.length || prev.size,
      }));

      const rows = items.map((item) => ({
        accountCode: item.accountCode,
        accountName: item.accountName,
        action: (
          <ActionCell
            item={{
              viewLink: `/templates/ledger-journal/view?accountCode=${item.accountCode}&year=${query.year}`,
            }}
          />
        ),
      }));

      setDataTableState((prev) => ({ ...prev, rows }));
    } catch (error) {
      console.error("Lỗi lấy danh sách tài khoản sổ cái:", error);
      setDataTableState((prev) => ({ ...prev, rows: [] }));
      setPaginationData((prev) => ({ ...prev, count: 0 }));
    } finally {
      setLoading(false);
    }
  }, [companyId, query]);

  useEffect(() => {
    fetchData();
  }, [fetchData, paginationData.page, paginationData.size]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <SoftBox p={3}>
            <SoftTypography variant="h5" fontWeight="medium">
              SỔ CÁI (Dùng cho hình thức kế toán Nhật ký chung)
            </SoftTypography>
            <SoftTypography variant="caption" color="text">
              Danh sách tài khoản có phát sinh trong năm {query.year}
            </SoftTypography>
          </SoftBox>
          <DataTable
            table={dataTableState}
            loading={loading}
            filters={filters}
            setFilters={setFilters}
            query={query}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}
